import { FormattedMessage } from 'react-intl'

export default function CollapsedNotification({
  isUpgraded,
  setIsCollapsed,
  updateShared,
  product,
}) {
  return (
    <div className='collapsed' onClick={() => setIsCollapsed(false)}>
      {isUpgraded ? (
        <span>
          <i className='font-icons ok-icon' />
          <FormattedMessage
            id='occupancy_selected'
            defaultMessage='Single occupancy upgrade selected'
          />
        </span>
      ) : (
        <span>
          <i className='font-icons fail-icon' />
          <FormattedMessage
            id='occupancy_not_selected'
            defaultMessage='Single occupancy upgrade not selected'
          />
        </span>
      )}
      <span className='change'>
        <FormattedMessage id='change' defaultMessage='Change' />
      </span>
    </div>
  )
}
